import { render } from "./EventRsvpComponent.vue?vue&type=template&id=73215fd5&ts=true"
import script from "./EventRsvpComponent.vue?vue&type=script&lang=ts"
export * from "./EventRsvpComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__